
export class Datatable {
    displayedColumns = [];
    identityColumn = false;
    //isView = true;
    isEdit = false;
    isDelete = false;
    isAdd = false;
    iscustom = false;
    gridName = "user"; 
    //isSession = false;    
    //hiddenColumns = [];
    indicators: "";
    data = [];
    parentData = [];
    gridControl = [{
        Icon : '',
        Name : '',
        ToolTip : '',
        Class:''
    }];
    columnKeyData = [];
    isViewDetail = false;
    //isSave = false;
}

export class SecDatatable {
    displayedColumns = [];
    identityColumn = false;
    //isView = true;
    isEdit = false;
    isDelete = false;
    isAdd = false;
    iscustom = false;
    gridName = "user"; 
    //isSession = false;    
    hiddenColumns = [];
    data = [];
    parentData = [];
    gridControl = [{
        Icon : '',
        Name : '',
        ToolTip : '',
        Class:''
    }];
    //isSave = false;
}


// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/models/datatable.model.ts